import { Controller } from "@hotwired/stimulus"

// Mounted only on the reader inside Preview's Tablet/Mobile frame (TMS-1771). A link
// there would otherwise load the next page inside the frame, where it would no longer
// be a framed preview. It goes to the whole page instead, and Preview remembers the
// width, so it comes back framed. In-page anchors, new-tab links and anything a
// reader script already handled are left alone.
export default class extends Controller {
  connect() {
    this.followLink = this.followLink.bind(this)
    document.addEventListener("click", this.followLink)
  }

  disconnect() {
    document.removeEventListener("click", this.followLink)
  }

  followLink(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const link = event.target.closest("a[href]")
    if (!link || (link.target && link.target !== "_self") || link.hasAttribute("download")) return

    const url = new URL(link.href, window.location.href)
    if (url.origin !== window.location.origin) return
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return

    event.preventDefault()
    url.searchParams.delete("embed")
    window.top.location.assign(url.toString())
  }
}
